const clearStyles = require('./clearStyles');
const setStyles = require('./setStyles');

module.exports = function stylesManager(overlayElement, wrapperElement) {
    return {
        clear: () => clearStyles(overlayElement, wrapperElement),
        set: () => setStyles(overlayElement, wrapperElement)
    };
}
